export default {
  pageInProgress: 'Sección no habilitada aún'
}

export const en = {
  pageInProgress: 'Section not yet enabled'
}

export const ca = {
  pageInProgress: 'Secció no habilitada encara'
}
